import { useState } from "react";
import { Button, Modal, Popup } from "semantic-ui-react";

import ScheduleViewContactsTable from "routes/campaign/components/email_schedule_contacts_table/ScheduleViewContactsTableV3";

function EmailableContactsModal({ disabled, campaignId, data }) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Modal
      trigger={
        <Popup
          disabled={!disabled}
          content={
            "Please select a template and fill out at least one filter condition"
          }
          trigger={
            <span>
              <Button
                type="button"
                size="tiny"
                content="View Contacts"
                disabled={disabled}
                onClick={handleOpen}
              />
            </span>
          }
        />
      }
      size="large"
      open={modalOpen}
      onClose={handleClose}
      closeIcon
    >
      <Modal.Header>Email Schedule Contacts</Modal.Header>
      <Modal.Content>
        <div className="tw:flex tw:h-[80vh] tw:w-full tw:flex-col tw:overflow-y-auto">
          <ScheduleViewContactsTable campaignId={campaignId} data={data} />
        </div>
      </Modal.Content>
    </Modal>
  );
}

export default EmailableContactsModal;
